var _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBigTree(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 622,
    height: 832,
    viewBox: "0 0 622 832",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 311.375,
    y1: 3.27835e-8,
    x2: 311.375,
    y2: 833,
    stroke: "white",
    strokeWidth: 0.75
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 310.735,
    y1: 608.735,
    x2: 621.735,
    y2: 297.735,
    stroke: "white",
    strokeWidth: 0.75
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 310.735,
    y1: 720.735,
    x2: 621.735,
    y2: 409.735,
    stroke: "white",
    strokeWidth: 0.75
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 310.735,
    y1: 496.735,
    x2: 621.735,
    y2: 185.735,
    stroke: "white",
    strokeWidth: 0.75
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 310.735,
    y1: 384.735,
    x2: 621.735,
    y2: 73.7349,
    stroke: "white",
    strokeWidth: 0.75
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    y1: -0.375,
    x2: 439.82,
    y2: -0.375,
    transform: "matrix(-0.707107 -0.707107 -0.707107 0.707107 311 609)",
    stroke: "white",
    strokeWidth: 0.75
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    y1: -0.375,
    x2: 439.82,
    y2: -0.375,
    transform: "matrix(-0.707107 -0.707107 -0.707107 0.707107 311 721)",
    stroke: "white",
    strokeWidth: 0.75
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    y1: -0.375,
    x2: 439.82,
    y2: -0.375,
    transform: "matrix(-0.707107 -0.707107 -0.707107 0.707107 311 497)",
    stroke: "white",
    strokeWidth: 0.75
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    y1: -0.375,
    x2: 439.82,
    y2: -0.375,
    transform: "matrix(-0.707107 -0.707107 -0.707107 0.707107 311 385)",
    stroke: "white",
    strokeWidth: 0.75
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    x1: 1.375,
    y1: 1.63918e-8,
    x2: 1.37496,
    y2: 833,
    stroke: "white",
    strokeWidth: 0.75
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBigTree);
export default __webpack_public_path__ + "static/media/big-tree.99635e66c1792a18b5c5728fd6646ae9.svg";
export { ForwardRef as ReactComponent };